import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoadingController, ModalController, AlertController, ToastController } from '@ionic/angular';
import { Logger } from '@app/core';
import { FirebaseService } from '@app/shared/services/firebase.service';
import { UtilitiesService } from '@app/shared/services/utilities.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
const log = new Logger('Login');

export interface Company {
  uid: string;
  name: string;
  businessType: string;
  companyWebsite: string;
}

export interface UserData {
  uid: string;
  email: string;
}

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})
export class AddCompanyComponent implements OnInit {
  public dataForm: FormGroup;
  public isLoading: boolean;
  public logo: any = null;
  public toUploadLogo: File = null;

  constructor(
    private formBuilder: FormBuilder,
    private loadingController: LoadingController,
    private firebase: FirebaseService,
    private modalController: ModalController,
    private utilities: UtilitiesService,
    private toastController: ToastController,
    private storage: AngularFireStorage
  ) {
    this.initForm();
    this.initData();
  }

  async presentAlertConfirm() {
    const alert = await this.toastController.create({
      header: 'Error al crear empresa',
      message: 'La empresa ya ha sido creada anteriormente, para continuar, usa el buscador y selecciona esta empresa.',
      buttons: [
        {
          text: 'ok'
        }
      ]
    });

    await alert.present();
  }

  ngOnInit() { }

  private initForm() {
    this.dataForm = this.formBuilder.group({
      name: ['', Validators.required],
      companyWebsite: [''],
      businessType: [''],
      description: ['']
    });
  }

  refillForm(data: any) {
    this.dataForm.setValue({
      name: data && data.name ? data.name : '',
      companyWebsite: data && data.companyWebsite ? data.companyWebsite : '',
      businessType: data && data.businessType ? data.businessType : '',
      description: data && data.description ? data.description : ''
    });
  }

  public async initData(): Promise<void> {
  }

  loadImg(imgInput: any) {
    const files: File[] = imgInput.files;
    if (files.length !== 0) {
      this.toUploadLogo = files[0];
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.logo = reader.result;
      };
    }
  }

  public async submit(): Promise<void> {
    this.isLoading = true;
    const loadingOverlay = await this.loadingController.create({});
    loadingOverlay.present();
    try {
      let data: any = {
        name: this.dataForm.get('name').value,
        companyWebsite: this.dataForm.get('companyWebsite').value,
        businessType: this.dataForm.get('businessType').value,
        description: this.dataForm.get('description').value,
        status: 'active',
        nameStr: '',
        slug: '',
        search: ['']
      };
      data.nameStr = '';
      data.search = [];
      const response = await this.firebase.createCompany(data);
      if (response && response.id) {
        let logoUrl = null;
        if (this.toUploadLogo) {
          const respStorage = await this.storage.upload(`companies/${response.id}`, this.toUploadLogo);
          logoUrl = await respStorage.ref.getDownloadURL();
          await this.firebase.afs.collection('companies').doc(response.id).update({ logo: logoUrl });
        }
        this.closeModal({ id: response.id, ...data, logo: logoUrl });
      } else {
        this.presentAlertConfirm();
      }
    } catch (error) {
      log.error(error);
    }
    loadingOverlay.dismiss();
    this.isLoading = false;
  }

  closeModal(data?: any) {
    this.modalController.dismiss(data);
  }
}
